export default {
      id: "Icon--close-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--close",
      toString: function () {
        return this.url;
      }
    }